import { useState, useEffect } from "react";
import "./styles/PanelPortafolio.css";
import Search from "../generales/Search";
import Action from "../Action";
import Modal from "react-modal";
import LoadSimple from "../LoadSimple";
import ModalCreateCis from "./ModalCreateException";
import TablePortafolio from "./TablePortafolio";
import InfoPortafolio from "./InfoPortafolio";
import Paginador from "../generales/Paginador";
import ModalCreateException from "./ModalCreateException";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "70%",
    padding: "20px",
  },
};
const PanelExcepciones = ({ server,setInternalError,languaje,mode }) => {
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [exceptions, setExceptions] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResult, setSearchResult] = useState(null);

  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataMantto, setDataMantto] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const crear = () => {
    setCreateCisModalOpen(true);
  };
  function closCreateManttoModal() {
    setEditActive(false);
    setCreateCisModalOpen(false);
  }
  const handleChangEdit = (cis) => {
    setEditActive(true);
    setDataMantto(cis);
    setCreateCisModalOpen(true);
  };
  useEffect(() => {
    search_devices();
  
  }, []);
  const buscar_cis = (ci_id) => {
    setLoadingCis(true);
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/ci_elements/" +
            ci_id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setLoadingCis(false);
          setDataMantto(data1.data);
          setCreateCisModalOpen(true);
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const regresar_cis = () => {
    setCisSelected([]);
    // setLoadingCis(true)
  };

  function search_devices() {
    setDevices({ data: devices.data, loading: true, error: devices.error });

    const fetchData = async () => {
      try {
        //console.log(`Bearer ${token_item}`)
        const token =
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY"; // Reemplaza con tu token de autenticación
        // const response = await fetch(server.url+'/api/v1/zabbix/db/hosts/relations/'+ubicacion.groupid, {
        const devicefilter = "";
        const subtypefilter = "";
        let andAux = devicefilter !== "" ? "&" : "?";
        andAux = subtypefilter !== "" ? andAux : "";
        const response = await fetch(
          // server.url + "/api/v1/zabbix/hosts/0",
          server.url + "/api/v1/cassia/hosts/catalog/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        if (response.ok) {
          const response_data = await response.json();
          setDevices({
            data: response_data.data,
            loading: false,
            error: devices.error,
          });
          setLoadingCis(false);
        } else {
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        // Manejo de errores
        setDevices({
          data: devices.data,
          loading: devices.loading,
          error: error,
        });
        //console.error(error);
      }
    };
    fetchData();
  }
  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };
  return (
    <>
      <div className="head-cis">
         <div className="title-cis">
         <Search
                     searchResults={searchResults}
                     setSearchResults={setSearchResults}
                     searchTerm={searchTerm}
                     setSearchTerm={setSearchTerm}
                     onSearch={handleSearch}
                     dataObject={dataUsers.data}
                     setDataObject={setDataUsers}
                     searchResult={searchResult}
                     setSearchResult={setSearchResult}
                     languaje={languaje}
                   />
           <div className={"cont-result-registers"+mode}>
          
                   <p style={{  textAlign: "center" }}>
                     &nbsp;
                     {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                       dataList.length +
                       ") " 
                       }
                   </p> 
           </div>
           <div className="cont-buttons-panel">
                   
                     <Action
                     disabled={false}
                     origen="Azul"
                     titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                     action={crear}
                   />
                   
                  
                 </div>
         </div>
       </div>
      <div className="cont-cis">
      <>
      <div className="main-panel-portafolio">
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode}>
              
          </div>
        <div className={"content-portafolio"+mode}>
       
        
          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
              {devices.loading ? (
                <LoadSimple />
              ) : (
                <>
                  {cisSelected.length === 0 ? (
                    <TablePortafolio
                      pageActual={pageActual}
                       limitList={limitList} startLimit={startLimit}
                      dataList={dataList}
                      cisSelected={cisSelected}
                      setCisSelected={setCisSelected}
                      registerIsValid={registerIsValid}
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      dataUsers={dataUsers}
                      setDataUsers={setDataUsers}
                      server={server}
                      setRegisterIsValid={setRegisterIsValid}
                      setData={setData}
                      setLoading={setLoading}
                      setError={setError}
                      handleChangEdit={handleChangEdit}
                      devices={devices}
                      exceptions={exceptions}
                      setEditActive={setEditActive}
                      languaje={languaje}
                      mode={mode}
                    ></TablePortafolio>
                  ) : (
                    ("")
                    // <InfoPortafolio
                    //   server={server}
                    //   portfolioSelected={cisSelected}
                    //   searchResults={searchResults}
                    //   setSearchResults={setSearchResults}
                    //   searchTerm={searchTerm}
                    //   setSearchTerm={setSearchTerm}
                    //   onSearch={handleSearch}
                    //   dataUsers={dataUsers}
                    //   setDataUsers={setDataUsers}
                    //   setCisSelected={setCisSelected}
                    //   registerIsValid={registerIsValid}
                    // ></InfoPortafolio>
                  )}
                </>
              )}
            </div>
          </div>
          <div className={"content-portafolio-footer"+mode}>
                    <div className="cont-display-paginador">
                    <Paginador  pages={pages}
                                pageActual={pageActual}
                                setPageActual={setPageActual}
                                mode={mode}></Paginador>
                    </div>
                    <div className="cont-display-paginador">
                      <div className={"cont-half-display-paginador"+mode}>
                      <div>
      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
        <option value={10}>10</option>
        <option value={50} >50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
        <option value={1000}>1000</option>
      </select>

      
    </div>
                  
                      </div>
                      <div className={"cont-half-display-paginador"+mode}>
                      <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                          ?  parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']}
                      </p>
                    </div>
                    </div>
        
                  </div>
          </div>
        </div>
      </div>
    <Modal
    isOpen={CreateCisModalOpen}
    // isOpen={false}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closCreateManttoModal}
    style={CreateCisModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
        <ModalCreateException
      devices={devices}
      server={server}
      editActive={editActive}
      setEditActive={setEditActive}
      dataMantto={dataMantto}
      setData={setData}
      loading={loading}
      setLoading={setLoading}
      setError={setError}
      setRegisterIsValid={setRegisterIsValid}
      closCreateManttoModal={closCreateManttoModal}
      languaje={languaje}
      mode={mode}
    ></ModalCreateException>
    </Modal>
    </>
      </div>
    </>
  );
};

export default PanelExcepciones;
